import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';

const Navbar = () => {
  return (
    <AppBar position="sticky" color="default" elevation={1}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              color: 'primary.main',
              fontWeight: 'bold'
            }}
          >
            Centrist Perspectives
          </Typography>
          <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
            <Button 
              color="inherit" 
              sx={{ 
                '&:hover': { 
                  backgroundColor: 'rgba(44, 62, 80, 0.04)' 
                } 
              }}
            >
              Home
            </Button>
            <Button 
              color="inherit"
              sx={{ 
                '&:hover': { 
                  backgroundColor: 'rgba(44, 62, 80, 0.04)' 
                } 
              }}
            >
              Articles
            </Button>
            <Button 
              color="inherit"
              sx={{ 
                '&:hover': { 
                  backgroundColor: 'rgba(44, 62, 80, 0.04)' 
                } 
              }}
            >
              Topics
            </Button>
            <Button 
              color="inherit"
              sx={{ 
                '&:hover': { 
                  backgroundColor: 'rgba(44, 62, 80, 0.04)' 
                } 
              }}
            >
              About
            </Button>
            <Button 
              variant="contained" 
              color="secondary"
              sx={{ 
                px: 3,
                '&:hover': { 
                  backgroundColor: 'secondary.dark' 
                } 
              }}
            >
              Login
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar; 